import { render } from "./ExportarGerminacao.vue?vue&type=template&id=04a1bba9"
import script from "./ExportarGerminacao.vue?vue&type=script&lang=js"
export * from "./ExportarGerminacao.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Workspace\\SalvandoArvores\\Codes\\salvando-arvores-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__